/**
 * ヘッダー（HEADER ）モジュール
 */
export const HEADER = {
  init() {
    const header = document.querySelector('.js-header')
    if (!header) return

    const CLASS_FIXED = 'is-fixed'
    // const CLASS_HIDDEN = 'is-hidden'

    let lastY = window.scrollY || 0
    let latestY = lastY
    let ticking = false
    let headerH = header.offsetHeight

    const syncHeaderHeight = () => {
      headerH = header.offsetHeight
      document.documentElement.style.setProperty('--site-header-h', `${headerH}px`)
    }

    const update = () => {
      const y = latestY
      // const dy = y - lastY

      if (y <= 0) {
        // header.classList.remove(CLASS_FIXED, CLASS_HIDDEN)
        header.classList.remove(CLASS_FIXED)
      } else {
        header.classList.add(CLASS_FIXED)

        // 下スクロール：ヘッダー高さを超えたら隠す
        // if (dy > 0 && y > headerH) header.classList.add(CLASS_HIDDEN)

        // 上スクロール：出す
        // if (dy < 0) header.classList.remove(CLASS_HIDDEN)
      }

      lastY = y
      ticking = false
    }

    const onScroll = () => {
      latestY = window.scrollY || 0
      if (!ticking) {
        ticking = true
        requestAnimationFrame(update)
      }
    }

    // 初期化
    syncHeaderHeight()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', syncHeaderHeight, { passive: true })

    if ('ResizeObserver' in window) {
      new ResizeObserver(syncHeaderHeight).observe(header)
    }

    // 初回反映
    onScroll()
  },
}
